module.exports = __webpack_public_path__ + "img/legume.0b2a933f.jpg";